<template>
  <section class="landing-teachers-section">
    <b-container>
      <b-row>
        <b-col cols="12" lg="6">
          <div class="landing-teachers-warpper-left">
            <h4 class="heading">Our Awesome Teachers</h4>
            <span class="subheading">Simply Brilliant Educators</span>
            <b-input-group size="lg" class="mb-3 teacher-input-group">
              <!--              <div class="d-flex">-->
              <!--                <b-input-group-prepend>-->
              <!--                  <b-button>-->
              <!--                    <font-awesome-icon icon="search"></font-awesome-icon>-->
              <!--                  </b-button>-->
              <!--                </b-input-group-prepend>-->
              <!--                &lt;!&ndash;<b-form-input&ndash;&gt;-->
              <!--                &lt;!&ndash;:placeholder="'Search Teachers by name or subject'"&ndash;&gt;-->
              <!--                &lt;!&ndash;&gt;</b-form-input>&ndash;&gt;-->
              <!--                <search-courses :is-teacher="true"></search-courses>-->
              <!--              </div>-->
              <search-bar :is-teacher="true"></search-bar>

              <b-input-group-append>
                <b-button size="sm" text="Button" variant="primary"
                  >Search Teachers</b-button
                >
              </b-input-group-append>
            </b-input-group>
            <b-link class="viewall" to="/all_teachers">
              <span>View all Teachers</span>
              <font-awesome-icon icon="chevron-right"></font-awesome-icon>
            </b-link>
          </div>
        </b-col>
        <b-col cols="12" lg="6">
          <div
            class="landing-teachers-warpper-right"
            :class="teacherArray.length > 4 ? 'slider-fade' : ''"
          >
            <tiny-slider
              v-bind="tinySliderOptions"
              class
              :controlsText="controlsText"
            >
              <div v-for="i in 5" :key="i">
                <teacher-card
                  v-if="teacherArray[i - 1]"
                  :teacher-data="teacherArray[i - 1]"
                />
              </div>
            </tiny-slider>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import VueTinySlider from "vue-tiny-slider";
import TeacherCard from "../Templates/TeacherCard";
import { teacherApi } from "../../services/teacherApi";
import { store } from "../../store/store";
import SearchCourses from "../Search/searchCourses";
import SearchBar from "../Search/SearchBar";

export default {
  name: "landingteacher",
  components: {
    SearchCourses,
    SearchBar,
    "tiny-slider": VueTinySlider,
    TeacherCard
  },
  data() {
    return {
      tinySliderOptions: {
        mouseDrag: true,
        loop: false,
        items: 3,
        gutter: 20,
        swipeAngle: 45,
        controls: true,
        responsive: {
          640: {
            items: 3,
            gutter: 0
          },
          768: {
            items: 4
          },
          992: {
            items: 3
          },
          1400: {
            items: 4,
            gutter: 5
          }
        }
      }
    };
  },
  props: {
    teacherArray: Array
  },
  computed: {
    controlsText() {
      const arrows = [];
      arrows.push(
        '<img src="data:image/png;base64,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">'
      );
      arrows.push(
        '<img src="data:image/png;base64,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">'
      );
      return arrows;
    }
  }
};
</script>

<style></style>
